import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: 'mbwp9d0u', 
  dataset: 'production',
  useCdn: false, // Ubah ke true untuk performa lebih stabil di production
  apiVersion: '2024-01-01',
});

// Penyesuaian agar tidak deprecated
const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
  // Tambahkan proteksi jika source kosong agar tidak crash
  if (!source) return { url: () => '/assets/placeholder.webp' };
  return builder.image(source);
};